import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  hover: { scale: 1.05, boxShadow: "0px 10px 20px rgba(255, 255, 255, 0.2)" },
};

const PlayBetCard = () => (
  <motion.div
    className="bg-white relative text-black rounded-3xl shadow-lg p-6 md:p-12 w-full md:w-[64%] h-[250px] md:h-[300px] flex transition-transform duration-300 hover:shadow-2xl overflow-hidden"
    initial="hidden"
    animate="visible"
    whileHover="hover"
    variants={cardVariants}
  >
    <div className="w-2/3">
      <h3 className="text-2xl md:text-4xl font-bold">Play & Earn</h3>
      <p className="text-xl md:text-2xl font-extralight mt-2">
        Use $ATH for all <br />
        in-game transactions.
      </p>
    </div>
    <img
      src="/assets/DiceIcon.png"
      alt="Dice"
      className="w-12 absolute top-6 right-6"
    />
    <img
      src="/assets/DiceIcon.png"
      alt="Small Dice"
      className="w-8 absolute top-40 md:top-16 right-52 md:right-40 rotate-45"
    />
    <img
      src="/assets/ROULETTE2.gif"
      alt="Roulette"
      className="absolute -bottom-10 md:top-[8%] w-3/5 md:w-1/2 right-0 md:right-[8%] rotate-[40deg]"
    />
  </motion.div>
);

const StakeEarnCard = () => (
  <motion.div
    className="bg-white relative text-black rounded-3xl shadow-lg p-6 md:p-12 w-full md:w-1/3 h-[250px] md:h-[300px] flex transition-transform duration-300 hover:shadow-xl"
    initial="hidden"
    animate="visible"
    whileHover="hover"
    variants={cardVariants}
  >
    <div>
      <h3 className="text-2xl md:text-4xl font-bold">Stake & Earn</h3>
      <p className="text-xl md:text-2xl font-extralight mt-2">
        Passive income <br />
        through staking <br />
        pools.
      </p>
    </div>
    <img
      src="/assets/PiggyBankIcon.png"
      alt="Piggy Bank"
      className="absolute bottom-0 right-0 w-3/5"
    />
  </motion.div>
);

const VoteDecideCard = () => (
  <motion.div
    className="bg-white text-black rounded-3xl shadow-lg p-6 md:p-12 w-full md:w-1/3 h-[250px] md:h-[350px] flex flex-col transition-transform duration-300 hover:shadow-xl"
    initial="hidden"
    animate="visible"
    whileHover="hover"
    variants={cardVariants}
  >
    <img src="/assets/VoteIcon.png" alt="Vote Button" className="w-4/5 mb-2" />
    <h3 className="text-2xl md:text-4xl mt-3 font-bold">Vote & Decide</h3>
    <p className="text-xl md:text-2xl font-extralight mt-3">
      Participate in <br />
      platform governance.
    </p>
  </motion.div>
);

const EarnRewardsCard = () => (
  <motion.div
    className="bg-white relative text-black rounded-3xl shadow-lg px-6 md:px-12 pt-6 md:pt-12 w-full md:w-[64%] h-[250px] md:h-[350px] flex flex-col justify-between transition-transform duration-300 hover:shadow-xl"
    initial="hidden"
    animate="visible"
    whileHover="hover"
    variants={cardVariants}
  >
    <div>
      <h3 className="text-2xl md:text-4xl font-bold">Earn Rewards</h3>
      <p className="text-xl md:text-2xl font-extralight mt-2">
        Unlock bonuses, complete challenges, and win.
      </p>
    </div>
    <div className="flex items-end justify-around w-full absolute bottom-0 left-0">
      <img
        src="/assets/RewardIcon.png"
        alt="Reward Badge"
        className="w-1/3 md:w-1/5"
      />
      <img
        src="/assets/TrophyIcon.png"
        alt="Trophy"
        className="w-1/3 md:w-1/3"
      />
      <img
        src="/assets/GiftBoxIcon.png"
        alt="Gift Box"
        className="w-1/3 md:w-1/5"
      />
    </div>
  </motion.div>
);

const WhatCanYouDo = () => {
  return (
    <section className="relative w-full flex flex-col items-center justify-start text-white overflow-hidden md:py-10">
      <div className="relative z-10 flex flex-col items-center">
        <motion.h2
          initial="hidden"
          animate="visible"
          variants={cardVariants}
          className="text-3xl md:text-5xl font-bold font-orbitron text-center my-16 mx-12"
        >
          What Can You Do with <span className="text-white">$ATH?</span>
        </motion.h2>

        <div className="flex flex-wrap items-center gap-6 justify-between w-full px-6 md:px-48">
          <PlayBetCard />
          <StakeEarnCard />
          <VoteDecideCard />
          <EarnRewardsCard />
        </div>
      </div>
    </section>
  );
};

export default WhatCanYouDo;
